







import { Component, Vue } from 'vue-property-decorator';
import ImageMasonry from './ImageMasonry.vue';
import { Image } from '@/models/Image';

export type CustomCols = {
    default: number;
    1700?: number;
    1300?: number;
    900?: number;
    600?: number;
};

@Component({
    components: {
        ImageMasonry
    }
})
export default class MultipleImages extends Vue {
    private images: Image[] = [];
    private showDescription: boolean = true;
    private galleryTitle: string = '';
    private customCols: CustomCols = {
        default: 5,
        1700: 4,
        1300: 3,
        900: 2,
        600: 1
    };

    constructor() {
        super();
        if (this.$attrs['data-content']) {
            try {
                this.images = JSON.parse(this.$attrs['data-content']);
            } catch (error) {
                console.error('Failed to parse data-content:', error);
            }
        }
        if (this.$attrs['data-show-description']) {
            this.showDescription = this.$attrs['data-show-description'].toLowerCase() === 'true';
        }
        if (this.$attrs['data-gallery-title']) {
            this.galleryTitle = this.$attrs['data-gallery-title'];
        }
        if (this.$attrs['data-default-columns']) {
            this.customCols[600] = parseInt(this.$attrs['data-default-columns'] as string, 10);
        }
        if (this.$attrs['data-small-columns']) {
            this.customCols[900] = parseInt(this.$attrs['data-small-columns'] as string, 10);
        }
        if (this.$attrs['data-medium-columns']) {
            this.customCols[1300] = parseInt(this.$attrs['data-medium-columns'] as string, 10);
        }
        if (this.$attrs['data-large-columns']) {
            this.customCols[1700] = parseInt(this.$attrs['data-large-columns'] as string, 10);
        }
        if (this.$attrs['data-extra-large-columns']) {
            this.customCols.default = parseInt(this.$attrs['data-extra-large-columns'] as string, 10);
        }
    }
}
